import axiosInstance from "./AxiosInstanceMain";

export const importLeadsApi = async (formData) => {
  const response = await axiosInstance.post("/generic-leads/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const exportLeadsApi = async (data = {}) => {
  const hasSelectedLeads = data && Array.isArray(data.leads) && data.leads.length > 0;

  if (hasSelectedLeads) {
    const response = await axiosInstance.post("/generic-leads/export", data, {
      responseType: "blob",
    });
    return response.data;
  }

  const response = await axiosInstance.get("/generic-leads/export", {
    params: data,
    responseType: "blob",
  });
  return response.data;
};

export const downloadReferenceTemplateApi = async () => {
  const response = await axiosInstance.get("/generic-leads/reference-template", {
    responseType: "blob",
  });
  return response.data;
};

export const createGenericLeadApi = async (data) => {
  const response = await axiosInstance.post("/generic-leads/create", data);
  return response.data;
};

export const updateGenericLeadApi = async (id, data) => {
  const response = await axiosInstance.patch(`/generic-leads/update/${id}`, data);
  return response.data;
};

export const getCombinedLeadsApi = async (params = {}) => {
  const response = await axiosInstance.get("/generic-leads/combined", { params });
  return response.data;
};

export const archiveLeadsBulkApi = async (data) => {
  const response = await axiosInstance.post("/generic-leads/archive-bulk", data);
  return response.data;
};

export const unarchiveLeadsBulkApi = async (data) => {
  const response = await axiosInstance.post("/generic-leads/unarchive-bulk", data);
  return response.data;
};
